// src/routes/routePaths.ts
export const ROUTES = {
    confirmarCambioContrasena: "/confirmar-cambio-contrasena",
    cambiarCorreo: "/cambiar-correo",
    verificarCorreo: "/verificar-correo",
    configurarDosPasos: "/verificacion-dos-pasos",
    recuperarContrasena: "/recuperar-contrasena",
    cambiarContrasena: "/cambiar-contrasena",
    verificarAcceso: "/verificar-acceso",
    login: '/login',
    register: '/register',
    landingpage: '/',
    coworking: '/espacios/coworking',
    empresarial: '/espacios/empresarial',
    nuestrosClientes: '/nuestros-clientes',
    nosotros: '/nosotros',
    nosotrosHistoria: '/nosotros/historia',
    nosotrosProyectos: '/nosotros/proyectos',
    contacto: '/contacto',
    serviciosCowork: '/servicios/cowork',
    serviciosOficinas: '/servicios/oficinas-privadas',
    serviciosSalas: '/servicios/salas-de-reunion',
    serviciosEventos: '/servicios/eventos',
    comunidadBanco: '/comunidad/banco-profesionales',
    comunidadMiembros: '/comunidad/miembros',
    comunidadNetworking: '/comunidad/networking',
    blog: '/blog',
    blogDetalle: '/blog/:slug',
    empresasConfianza: '/empresas-confianza',
    bannerHero: '/banner-hero',

    serviciosCategory: '/servicios/:categoryId',
    serviciosDetalles: '/servicios/:categoryId/servicio/:servicioId',
    reservaYa: '/reservaya',
    misCitas: '/mis-citas',
    solicitudesReserva: '/solicitudes-reserva',
    misCotizaciones: '/solicitudes-reserva/cotizaciones',
    misFacturas: '/solicitudes-reserva/facturas',
    misCitasDetalle: '/mis-citas/:id',
    misCitasSesiones: '/mis-citas/:id/sesiones',
    perfil: '/perfil',
    parati: '/parati',
    miDashboard: '/midashboard',
    dashboard: '/dashboard',
    usuarios: '/usuarios',
    reglasNivel: '/reglas-nivel',
    nivelUsuarios: '/nivelusuarios',
    userLevelPermisos: '/userlevels/:id/userlevelpermisos',
    activity: '/activity',
    security: '/security',
    services: '/services',
    categoriasProductos: '/categoriasproductos',
    productos: '/productos',
    servicesHistory: '/services/history',
    categorias: '/categorias',
    categoriesHistory: '/categories/history',
    spaces: '/spaces',
    spacesHistory: '/spaces/history',
    spacesServices: '/spaces-services',
    spacesServicesHistory: '/spaces-services/history',
    plan: '/plan',
    plansHistory: '/plans/history',
    planConfig: '/planconfig',
    pricePlan: '/priceplan',
    pricePlanHistory: '/priceplan/history',
    posList: '/pos-list',
    reservas: '/reservas',
    historialPagosCita: '/historial-pagos/cita/:citaId',
    reservasCalendario: '/reservas-calendario',
    reporteLlegadasHoy: '/reportes/llegadas-hoy',
    reporteCancelaciones: '/reportes/cancelaciones',
    reporteReservas: '/reportes/reservas',
    reporteHorasRegalo: '/reportes/horas-regalo',
    reporteDeudas: '/reportes/deudas',
    reportePagosSesiones: '/reportes/pagos-sesiones',
    reportePagos: '/reportes/pagos',
    reporteCaja: '/reportes/caja',
    reporteUso: '/reportes/uso',
    reporteClientes: '/reportes/clientes',
    reporteActividad: '/reportes/actividad',
    reporteSeguridad: '/reportes/seguridad',
    ventasDetalle: '/ventas/detalle/:id',
    reporteCafeteria: '/reportes/cafeteria',
    reservasDetalle: '/reservas/detalle/:id',
    reservasEditar: '/reservas/editar/:id',
    posListSesiones: '/pos-list/:posId/sesiones',
    sesionesPos: '/sesiones-pos/:sesionId',
    sesionesPosPagos: '/sesiones-pos/:sesionId/pagos',
    posConfig: '/pos-config/:id',
    coupon: '/coupon',
    couponUsed: '/coupon-used',
    citaCouponDetalle: '/cita-coupon-detalle/:id',
    sugerenciasCitas: '/sugerencias-citas',
    kardexCitas: '/kardex-citas',
    kardexCitasDetalle: '/kardex-citas/detalle/:usuarioId',
    kardexHistorialPagos: '/dashboard/kardex-clientes/historial-pagos/:usuarioId?',
    configRegistro: '/config-registro',
    configHorasRegalo: '/config-horas-regalo',
    configCorrespondencia: '/config-correspondencia',
    correspondencias: '/correspondencias',
    afiliados: '/afiliados',
    miCorrespondencia: '/mi-correspondencia',
    seguimientoPublico: '/seguimiento/:token',
    kardexSesiones: '/dashboard/kardex-clientes/sesiones/:citaId',
    tiposPago: '/tipos-pago',
    configPago: '/config-pago',
    permission: '/permission',
    clients: '/clients',
    personnel: '/personnel',
    profile: '/profile',
    codigosOrden: '/codigos-orden',
    codigoPagoOrden: '/codigo-pago-orden',
    pagos: '/pagos',
    system: '/system',
    sesionesDePos: '/sesiones-de-pos',
    codigoSesionPosOrden: '/codigo-sesionpos-orden',
    sucursales: '/sucursales',
    empresa: '/empresa',
    facturaDetalle: '/empresa/facturas/:id',
    blogCategoria: '/blog-categoria',
    blogPublicaciones: '/blog-post',
    ramasProfesionales: '/ramas-profesionales',
    eventosAdmin: '/eventos-admin',
    pointOfSale: '/point-of-sale',
    pointOfSaleVerReservas: '/point-of-sale/ver-reservas/:espacioId',
} as const;

// Para el dropdown en los modales
export const ROUTE_PATHS = Object.values(ROUTES);


